import { useEffect, useRef, useState } from "react";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import { InputBlock } from "./InputBlock";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { useTextEditor } from "../../../components/textEditor/textEditor";
import { Checkbox } from "../../../components/checkbox/checkbox";
import { Input } from "../../../components/input/input";
import { DeleteIcon, PlusIcon } from "../../../assets/icons";
import { Spring } from "../../../components/spring/spring";
import classNames from "classnames";
import KnowledgeAPI from "../../../api/KnowledgeAPI";

import styles from "./addTest.module.css";

import { Text } from "../../../components/text/text";

const AnswerItem = ({ val, setVal, active, setActive, onDelete, error, duplicateError }) => {
    return (
        <div className={styles.answer_item}>
            <Checkbox
                checked={active}
                onChange={setActive}
                error={error}
            />
            <Input
                placeholder="Введите вариант ответа"
                type="text"
                value={val}
                setValue={setVal}
                error={val.length < 1 || duplicateError}
            />
            <DeleteIcon
                onClick={onDelete}
            />
        </div>
    );
}

export const AddTestPage = () => {
    const { categoryId } = useParams();

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState(false);

    const [rewardExp, setRewardExp] = useState(0);

    const [editor, toHtml] = useTextEditor();

    const [answers, setAnswers] = useState([]);
    const [answersError, setAnswersError] = useState(false);

    const [correctAnswer, setCorrectAnswer] = useState(null);
    const [correctAnswerError, setCorrectAnswerError] = useState(false);

    useEffect(() => {
        setAnswersError(false);
    }, [answers]);

    useEffect(() => {
        setNameError(false);
    }, [name]);

    useEffect(() => {
        setCorrectAnswerError(false);
    }, [correctAnswer]);

    const validateData = () => {
        let error = false;

        if (name.length <= 1) {
            setNameError(true);
            error = true;
        }

        if (answers.length < 2) {
            setAnswersError(true);
            error = true;
        }

        for (const answer of answers) {
            if (answer.value.length < 1) {
                error = true;
            }
        }

        if (correctAnswer === null) {
            setCorrectAnswerError(true);
            error = true;
        }

        for (const answer of answers) {
            if (answers.findIndex(el => el.id !== answer.id && el.value === answer.value) !== -1) {
                error = true;
                break;
            }
        }

        return error;
    }

    const { cafeId } = useParams();
    const navigate = useAnimatedNavigate()
    const [loading, setLoading] = useState(false);
    const onSave = () => {
        if (validateData()) return;

        setLoading(true);
        KnowledgeAPI
            .createTest(
                categoryId,
                name,
                toHtml(),
                answers.map(el => el.value),
                answers.findIndex(el => el.id === correctAnswer),
                rewardExp
            )
            .then(() => {
                navigate(`/admin/${cafeId}/knowledge/${categoryId}`);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }

    const maxId = useRef(0);

    return (
        <>
            <AdminHeader title="Добавить тест" />

            <InputBlock
                type="text"
                title="Введите название теста"
                value={name}
                setValue={setName}
                error={nameError}
            />

            <InputBlock
                type="textEditor"
                title="Введите текст вопроса"
                editor={editor}
            />

            <InputBlock
                type="number"
                title="Количество опыта за прохождение"
                value={rewardExp}
                setValue={setRewardExp}
            />

            <div className={classNames(styles.input_block, styles.answers, { [styles.error]: answersError })}>
                <Text as="div" variant="caption" className={styles.input_block_title} >
                    Варианты ответа
                </Text>
                <div className={styles.content}>
                    {
                        answers.map(data => (
                            <AnswerItem
                                key={data.id}
                                active={correctAnswer === data.id}
                                setActive={() => setCorrectAnswer(data.id)}
                                val={data.value}
                                error={correctAnswerError}
                                setVal={newVal => {
                                    setAnswers(prev => prev.map(el => el.id === data.id ? { ...el, value: newVal } : el));
                                }}
                                onDelete={() => {
                                    if (data.id === correctAnswer) {
                                        setCorrectAnswer(null);
                                    }
                                    setAnswers(prev => prev.filter(el => el.id !== data.id));
                                }}
                                duplicateError={answers.findIndex(el => el.id !== data.id && el.value === data.value) !== -1}
                            />
                        ))
                    }

                    <Button
                        text={
                            <div style={{ display: "flex", gap: "4px", alignItems: "center", justifyContent: "center" }}>
                                <PlusIcon />
                                Добавить вариант ответа
                            </div>
                        }
                        view="thin"
                        type="secondary"
                        onClick={() => {
                            maxId.current++;
                            setAnswers(prev => [
                                ...prev,
                                {
                                    id: maxId.current,
                                    value: "",
                                }
                            ])
                        }}
                    />
                </div>
            </div>

            <Spring />

            <Button
                text="Добавить тест"
                onClick={onSave}
                disabled={loading}
            />
        </>
    )
}
